import { isMobile, browserName, browserVersion, osName } from './mobile-browser-detect.js'

export function checkBrowserSupport() {
  const browser = browserName.toLowerCase()
  const version = Number(browserVersion.split('.')[0])
  const os = osName.toLowerCase()

  const notSupportedDesktop = {
    chrome: { below: 41 },
    opera: { below: 28 },
    firefox: { below: 41 },
    safari: { below: 10 },
    edge: { fullySupported: true },
    yandex: { notSupported: true },
    ie: { notSupported: true },
  }

  const notSupportedMobile = {
    ios: { below: 10 },
    android: { below: 4 }
  }

  const rules = isMobile ? notSupportedMobile[os] : notSupportedDesktop[browser]

  if (!rules) return true
  if (rules.notSupported) return false
  if (rules.fullySupported) return true
  if (isNaN(version)) return true
  if (rules.below != null && version < rules.below) return false
  return true
}
